import { motion } from "framer-motion";
import VideoScriptCard from "@/components/VideoScriptCard";
import { HOME } from "@/constants/testIds";

const SAMPLE_SCRIPT = {
  hook_text: "POV: your app has 4.9 stars and nobody knows it exists",
  voiceover_script:
    "If your app is amazing but downloads are flat, this is the problem. Ninety percent of apps fail because of discovery, not quality. Here's the fix: optimize your ASO keywords, ship one 15-second demo video a day, and spend five dollars testing three hooks. That's it. No agency, no ad budget, just the system.",
  broll_search_terms: ["phone app screen", "creator filming content", "startup team laptop", "city aerial night"],
  on_screen_captions: [
    { time: "0-3s", text: "Your app has 4.9 stars..." },
    { time: "3-8s", text: "...and nobody knows it exists." },
    { time: "8-15s", text: "90% of apps fail from discovery, not quality." },
    { time: "15-25s", text: "Fix ASO. Ship 1 video/day. Test $5 hooks." },
  ],
  call_to_action: "Get your free growth engine → link in bio",
};

const SampleVideoShowcase = () => {
  return (
    <section id="sample-script" data-testid={HOME.sampleScriptSection} className="relative py-24 sm:py-32 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-4"
        >
          Video Production Engine — Sample Output
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-none mb-16 max-w-3xl"
        >
          One prompt. A full TikTok/Reels-ready script, timed captions, and b-roll.
        </motion.h2>

        <VideoScriptCard script={SAMPLE_SCRIPT} testId="sample-video-script-card" />
      </div>
    </section>
  );
};

export default SampleVideoShowcase;
